import request from '@/utils/request'

// 用户注册
export function register(data) {
  return request({
    url: '/api/register',
    method: 'post',
    data
  })
}

// 用户登录
export function login(data) {
  return request({
    url: '/api/login',
    method: 'post',
    data
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/api/user/info',
    method: 'get'
  })
}

// 获取收藏列表
export function getFavorites() {
  return request({
    url: '/api/favorites',
    method: 'get'
  })
}

// 添加收藏
export function addFavorite(data) {
  return request({
    url: '/api/favorites',
    method: 'post',
    data
  })
}

// 删除收藏
export function removeFavorite(relicId) {
  return request({
    url: `/api/favorites/${relicId}`,
    method: 'delete'
  })
}

// 检查是否已收藏
export function checkFavorite(relicId) {
  return request({
    url: `/api/favorites/check/${relicId}`,
    method: 'get'
  })
}
